/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bot_Never_4Inputs */

const en_bot_never_4 = /** @type {(inputs: Bot_Never_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read sign-in, checkout or payment pages, or the sites of banks, e-wallets and payment providers.`)
};

const id_bot_never_4 = /** @type {(inputs: Bot_Never_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Membaca halaman masuk, checkout, atau pembayaran, maupun situs bank, dompet digital, dan penyedia pembayaran.`)
};

/**
* | output |
* | --- |
* | "Read sign-in, checkout or payment pages, or the sites of banks, e-wallets and payment providers." |
*
* @param {Bot_Never_4Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const bot_never_4 = /** @type {((inputs?: Bot_Never_4Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bot_Never_4Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_bot_never_4(inputs)
	return en_bot_never_4(inputs)
});